// The interceptor rejects with the response body alone, so the HTTP status rides beside it here instead of on it.
const statuses = new WeakMap<object, number>();

export const recordRejectionStatus = (body: unknown, status: number) => {
  if (typeof body === "object" && body !== null) {
    statuses.set(body, status);
  }
  return body;
};

export const rejectionStatusOf = (body: unknown): number | undefined =>
  typeof body === "object" && body !== null ? statuses.get(body) : undefined;
